var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseCircleSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/pause-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9697 2C6.44973 2 1.96973 6.48 1.96973 12C1.96973 17.52 6.44973 22 11.9697 22C17.4897 22 21.9697 17.52 21.9697 12C21.9697 6.48 17.4997 2 11.9697 2ZM10.7197 15.03C10.7197 15.51 10.5197 15.7 10.0097 15.7H8.70973C8.19973 15.7 7.99973 15.51 7.99973 15.03V8.97C7.99973 8.49 8.19973 8.3 8.70973 8.3H9.99973C10.5097 8.3 10.7097 8.49 10.7097 8.97V15.03H10.7197ZM15.9997 15.03C15.9997 15.51 15.7997 15.7 15.2897 15.7H13.9997C13.4897 15.7 13.2897 15.51 13.2897 15.03V8.97C13.2897 8.49 13.4897 8.3 13.9997 8.3H15.2897C15.7997 8.3 15.9997 8.49 15.9997 8.97V15.03Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircleSvg);
export default __webpack_public_path__ + "static/media/PauseCircleSvg.5aa47e1dc3fa64f683201cbc9bd686ec.svg";
export { ForwardRef as ReactComponent };